import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
// import MusicsButtonWrapper from '../containers/MusicsButtonWrapperContainer';
import LyricsPane from '../containers/LyricsPaneContainer';
import CommercialInfosContainer from '../containers/CommercialInfosContainer';

const MetaInfo = ({ metaType }) => (
    <div className="meta-info">
        {metaType === 'commercial' ?
            <CommercialInfosContainer /> :
            <React.Fragment>
                <LyricsPane />
                {/* <MusicsButtonWrapper /> */}

            </React.Fragment>}
    </div>
);

MetaInfo.propTypes = exact({
    metaType: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),
});

export default MetaInfo;
